import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformType} from '../../../../global/util/enum/InformType';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {Workflow} from '../../../model/Workflow';
import {Document} from '../../../model/Document';
import {PersonService} from '../../../service/person.service';
import {Person} from '../../../model/Person';
import {Constant} from '../../../../global/util/Constant';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {DocumentUtil} from '../../../../global/util/DocumentUtil';
import {SignType} from '../../../../global/util/enum/SignType';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {AddEditPersonComponent} from '../../person/add-edit-person/add-edit-person.component';
import {AuthService} from '../../../service/auth/auth.service';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Router} from '@angular/router';
import {ApplicationService} from '../../../service/application.service';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {WorkflowDataService} from '../../../service/data/workflow-data.service';

@Component({
  selector: 'app-add-document-one-dynamic',
  templateUrl: './add-document-one-dynamic.component.html',
  styleUrls: ['./add-document-one-dynamic.component.css']
})
export class AddDocumentOneDynamicComponent implements OnInit, OnDestroy {
  public loading: boolean;
  public documentForm: FormGroup;
  public document = new Document();
  public workflows: Workflow[] = [];
  public workflowSelected = new Workflow();
  public people: Person[] = [];
  public progressUpdate = 0;
  public enterpriseIdSelected: number;
  public uploading = false;
  private type = 1;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_USER = Constant.ROLE_USER;
  public title = 'TITLE.SIGN-DYNAMICALLY';
  public document2Modify: Document;

  constructor(public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              public documentService: DocumentService,
              public personService: PersonService,
              private router: Router,
              public authenticationService: AuthService,
              private applicationService: ApplicationService,
              private workflowDataService: WorkflowDataService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.createForm();
  }

  ngOnInit() {
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN)) {
      // this.workflows = LocalStorage.getWorkflowsExtraBy(this.enterpriseIdSelected);
      this.workflows = this.workflowDataService.getWorkflows();
    } else {
      this.workflows = LocalStorage.getWorkflowsByPerson();
    }
    if (this.isDocModification) {
      this.title = this.translate.instant('TITLE.DOCUMENT-MODIFICATION');
      this.document.subject = this.document2Modify.subject;
      this.workflows = DocumentUtil.extractOnlyNecesaryWorkflowsBy(this.workflows, SignType.Dynamic).filter(workflow => workflow.id === this.document2Modify.workflowId);
    } else {
      // TODO Investigate and improvement pass values by reference and avoid a return of this.workflows
      this.workflows = DocumentUtil.extractOnlyNecesaryWorkflowsBy(this.workflows, SignType.Dynamic);
    }
    this.workflowSelected = this.workflows[0];
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
        this.activeModal.close(InformType.Anything);
      }
    }, 300);
  }

  ngOnDestroy() {
    const items = [
      'others',
      'identificationdocuments'];
    LocalStorage.removeItems(items);
  }

  public isEditable(index: number): boolean {
    const group = this.arrayParticipant.at(index);
    return Constant.INVITED === group.get('participantType').value;
  }

  public isDigitalSignature(index: number): boolean {
    const group = this.arrayParticipant.at(index);
    return TypeSignature.DIGITAL === Number(group.get('typeSignature').value);
  }

  /**
   * Carga los datos necesarios para el módulo actual y luego abre el modal para agregar/editar persona
   */
  public loadRequiredDataAndOpenModal(index: number) {
    this.loading = true;
    this.title = this.translate.instant('TITLE.SIGN-ONE-TO-ONE');
    const url = Constant.ROOT_API_V1.concat('/required-data?component=add-person');
    this.applicationService.get(url).subscribe((next: any) => {
      this.loading = false;
      LocalStorage.setUpEmbeddedInfo(next);
      this.openAddSearchPerson(index);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  public openAddSearchPerson(index: number) {
    const group = this.arrayParticipant.at(index);
    let title;
    const modalRef = this.modalService.open(AddEditPersonComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.personReceived = new Person();
    modalRef.componentInstance.purpose4Form = Constant.ADD_ON_DOCS;
    modalRef.componentInstance.enterpriseIdSelected = LocalStorage.getEnterpriseIdView();
    modalRef.result.then((result) => {
      if (result === -1) {
        return;
      }
      group.get('id').setValue(result.id);
      group.get('documentNumber').setValue(result.documentNumber);
      group.get('fullname').setValue(result.fullname);
      group.get('replaceable').setValue(result.replaceable);
      group.get('replaced').setValue(Constant.REPLACED);
      title = this.translate.instant('TITLE.PERSON');
      if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, title);
      } else if (InformType.Success === result) {
        Dialog.show(InformType.Success, title);
      } else if (InformType.Info === result) {
        Dialog.show(InformType.Info, title);
      }
    });
  }

  public save(): void {
    if (this.documentForm.invalid) {
      Object.values(this.documentForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    const replacements = this.getReplacementsOf();
    const formData = new FormData();
    formData.append('type', String(this.type));
    formData.append('subject', this.document.subject);
    formData.append('workflowId', String(this.workflowSelected.id));
    formData.append('replacements', replacements);
    formData.append('managements', '');
    formData.append('typePersons', '');
    for (const doc of this.arrayDocument.controls) {
      formData.append('files', doc.value.file);
    }
    formData.append('documents2signByParticipant', JSON.stringify([]));
    let url;
    if (this.isDocModification) {
      formData.append('reasonModification', this.document.reasonModification);
      url = Constant.ROOT_API_V1.concat('/documents/', String(this.document2Modify.id), '/modify');
    } else {
      url = Constant.ROOT_API_V1.concat('/documents');
    }
    this.documentService.uploadTo(url, formData).subscribe((event: HttpEvent<any>) => {
      this.uploading = true;
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.uploading = false;
          this.activeModal.close(InformType.Success);
          break;
      }
    }, error => {
      this.progressUpdate = 0;
      this.processError(error);
    });
  }

  private getReplacementsOf(): string {
    let replacements = '';
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < this.arrayParticipant.length; index++) {
      const group = this.arrayParticipant.at(index);
      const personId = group.get('id').value;
      const typesignature = group.get('typeSignature').value;
      const integrity = group.get('integrity').value ? '1' : '0';
      const dragRubric = group.get('dragRubric').value ? '1' : '0';
      const tsa = group.get('tsa').value ? '1' : '0';
      replacements += String(index + 1)
        .concat(',')
        .concat(personId)
        .concat(',')
        .concat(tsa)
        .concat(',')
        .concat(typesignature)
        .concat(',')
        .concat(integrity)
        .concat(',')
        .concat(dragRubric)
        .concat('|');
    }
    const lastIndexOf = replacements.lastIndexOf('|');
    return replacements.substring(0, lastIndexOf);
  }

  cancel(): void {
    // TODO Investigate how to cancel upload request correctly
    this.activeModal.close();
  }

  private createForm() {
    this.documentForm = this.formBuilder.group(
      {
        workflow: [''],
        subject: ['', [Validators.required]],
        arrayDocument: this.formBuilder.array([]),
        arrayParticipant: this.formBuilder.array([]),
        reasonModification: ['']
      });
    this.addRow();
    this.addRowParticipant();
  }

  public isInvalidControl(ctrlName: string) {
    return this.documentForm.get(ctrlName).invalid && this.documentForm.get(ctrlName).touched;
  }

  public changeStatus(event, index: number) {
    this.title = this.translate.instant('TITLE.SIGN-DYNAMICALLY');
    const fileSelected = (event.target as HTMLInputElement).files[0];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.title, this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    const group = this.arrayDocument.at(index);
    group.patchValue({
      file: fileSelected,
      filename: fileSelected.name
    });
    group.get('file').updateValueAndValidity();
  }

  get areValidPeople() {
    return !(this.arrayParticipant.value.find(person => Constant.NOT_REPLACED === person.replaced) !== undefined);
  }

  get arrayDocument() {
    return this.documentForm.get('arrayDocument') as FormArray;
  }


  get arrayParticipant() {
    return this.documentForm.get('arrayParticipant') as FormArray;
  }

  public addRow() {
    const group = this.formBuilder.group({
      file: [null, [Validators.required]],
      filename: [''],
      workflow: [this.workflowSelected]
    });
    this.arrayDocument.push(group);
  }

  public addRowParticipant() {
    const group = this.formBuilder.group({
      id: [],
      documentNumber: ['00000000'],
      fullname: [this.translate.instant('LABEL.PENDING')],
      tsa: [''],
      integrity: [''],
      dragRubric: [''],
      typeSignature: [TypeSignature.DIGITAL],
      replaceable: [Constant.REPLACEABLE],
      participantType: [Constant.INVITED],
      replaced: [0],
    });
    this.arrayParticipant.push(group);
  }

  public reload(group: AbstractControl, callerControlName: string) {
    const typeSignature = Number(group.get(callerControlName).value);
    if (TypeSignature.DIGITAL === typeSignature) {
      group.get('integrity').setValue(Constant.ZERO_INDEX);
    } else {
      group.get('tsa').setValue(Constant.ZERO_INDEX);
    }
  }

  public deleteRow(index: number) {
    this.arrayDocument.removeAt(index);
  }

  public deleteParticipantRow(index: number) {
    this.arrayParticipant.removeAt(index);
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  private processError(error: any) {
    const status = error.status;
    this.title = this.translate.instant('TITLE.SIGN-DYNAMICALLY');
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else {
        Dialog.show(InformType.Danger, this.title);
      }
    } else {
      Dialog.show(InformType.Danger, this.title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  get isDocModification(): boolean {
    return this.document2Modify !== undefined;
  }
}
